import { render, staticRenderFns } from "./PortionForm.vue?vue&type=template&id=19c0a71a&"
import script from "./PortionForm.vue?vue&type=script&lang=ts&"
export * from "./PortionForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports